import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const CustomCursor = () => {
  const [mouse, setMouse] = useState({ x: 0, y: 0 });
  const [hover, setHover] = useState(false);

  // Track mouse
  useEffect(() => {
    const move = (e) => {
      setMouse({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, []);

  // Hover detection
  useEffect(() => {
    const add = () => setHover(true);
    const remove = () => setHover(false);

    document.querySelectorAll("a, button").forEach((el) => {
      el.addEventListener("mouseenter", add);
      el.addEventListener("mouseleave", remove);
    });

    return () => {
      document.querySelectorAll("a, button").forEach((el) => {
        el.removeEventListener("mouseenter", add);
        el.removeEventListener("mouseleave", remove);
      });
    };
  }, []);

  return (
    <>
      {/* OUTER RING */}
      <motion.div
        className="fixed top-0 left-0 pointer-events-none z-[9998]"
        animate={{
          x: mouse.x - 25,
          y: mouse.y - 25,
          scale: hover ? 1.8 : 1,
        }}
        transition={{
          type: "spring",
          stiffness: 120,
          damping: 25,
          mass: 0.8,
        }}
      >
        <div
          className={`w-8 h-8 rounded-full border transition-all duration-300
          ${
            hover
              ? "border-cyan-400 shadow-[0_0_20px_rgba(34,211,238,0.8)]"
              : "border-lime-400"
          }`}
        />
      </motion.div>

      {/* INNER DOT */}
      <motion.div
        className="fixed top-0 left-0 pointer-events-none z-[9999]"
        animate={{
          x: mouse.x - 4,
          y: mouse.y - 4,
        }}
        transition={{
          type: "tween",
          ease: "easeOut",
          duration: 0.08,
        }}
      >
        <div
          className={`w-4 h-4 rounded-full
          ${hover ? "bg-cyan-400" : "bg-lime-400"}`}
        />
      </motion.div>
    </>
  );
};

export default CustomCursor;
